import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirects any non-locale-prefixed route to its German equivalent.
 * E.g. /startseite → /de/startseite
 *
 * Die öffentliche englische Version ist derzeit deaktiviert (nur DACH),
 * daher wird immer auf /de umgeleitet – unabhängig von einer gespeicherten
 * Spracheinstellung.
 */
export const LocaleRedirect: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  // /en/… → /de/…
  if (/^\/en(\/|$)/.test(path)) {
    const target = path.replace(/^\/en(?=\/|$)/, '/de') || '/de';
    return <Navigate to={target + location.search + location.hash} replace />;
  }

  // Already has the German locale prefix
  if (/^\/de(\/|$)/.test(path)) {
    return <Navigate to={path + location.search + location.hash} replace />;
  }

  const newPath = path === '/' ? '/de' : `/de${path}`;
  return <Navigate to={newPath + location.search + location.hash} replace />;
};
